FamilycardsImageLibrary.controller('browseImagesController', [ '$scope', '$http', function( $scope, $http ) {

	$scope.images = [];
	$scope.imageFilters = {};
	$scope.infinitescroll = {};
	$scope.search = {};
	$scope.favoriteLoading = {};
	$scope.disabledLoading = false;
	$scope.editModeImages = {};
	$scope.editModeActive = false;
	$scope.noResults = false;

	var protocol = window.location.protocol;
	var hostname = window.location.hostname;
	var nextPageUrl = '/api/beelden?page=1';
	var initialLoad = true;

	if( typeof preset_theme !== 'undefined' ) {
		$scope.imageFilters.theme = preset_theme;
	}

	if( typeof preset_search_query !== 'undefined' ) {
		$scope.imageFilters.searchQuery = preset_search_query;
		$scope.search.query = preset_search_query;
	}


	$scope.switchFavorite = function( $action, $id, $image ) {

		$scope.favoriteLoading[$id] = true;

		$http({
			method: 'GET',
			url: protocol + '//' + hostname + '/api/beelden/' + $id + '/favorieten/' + $action,
		}).
		success( function( response, status, headers, config ) {
			$image.is_favorite = response.isFavorite;
			jQuery('.favorite-holder').html('<span class="favorite-counter">' + response.count + '</div>');
			$scope.favoriteLoading[$id] = false;
		}).
		error(function(data, status, headers, config) {});
	}

	$scope.switchEditSelection = function( imageId ) {
		if( $scope.editModeImages[imageId] ) {
			$scope.editModeImages[imageId] = false;
		} else {
			$scope.editModeImages[imageId] = true;
		}
	}

	$scope.saveDisabledImages = function() {
		$scope.disabledLoading = true;

		$http({
			method: 'POST',
			url: protocol + '//' + hostname + '/api/mijn-account/instellingen',
			data: { 'disabled_images': $scope.editModeImages }
		}).
		success( function( response, status, headers, config ) {
			$scope.disabledLoading = false;
			$scope.editModeActive = false;
			$scope.$emit( 'reloadImages' );
		}).
		error(function(data, status, headers, config) {});
	}

	$scope.getImages = function getImages()  {

		if ($scope.infinitescroll.busy) return;
		if ( !nextPageUrl ) return;

    	$scope.infinitescroll.busy = true;

		$http({
			method: 'GET',
			url: nextPageUrl + constructParameters(),
		}).
		success( function( response, status, headers, config ) {
			nextPageUrl = response.next_page_url;

			for ( var image in response.data ) {
				$scope.images.push(response.data[image]);
				if( response.data[image].is_disabled_individually ) {
					$scope.editModeImages[response.data[image].id] = true;
				}
			}

			for ( var filter in response.filters ) {
				$scope.imageFilters[filter] = response.filters[filter];
			}

			if( $scope.images.length == 0 ) {
				$scope.noResults = true;
			} else {
				$scope.noResults = false;
			}
			
			$scope.infinitescroll.busy = false;
		}).
		error(function(data, status, headers, config) {});

	}

	$scope.addSearchFiter = function( search ) {
		$scope.imageFilters.searchQuery = search.query;
	}

	$scope.removeFilter = function( filterKey ) {
		delete $scope.imageFilters[filterKey];
	}

	$scope.removeAllFilters = function() {
		$scope.imageFilters = {};
	}

	$scope.$on('reloadImages', function( event ) {
		nextPageUrl = '/api/beelden?page=1';
		$scope.images = [];
		$scope.getImages();
	});

	function constructParameters() {

		var urlParameters = {};
		var returnUrl = '';

		if( $scope.imageFilters.theme ) {
			urlParameters['theme'] = $scope.imageFilters.theme;
		}

		if( $scope.imageFilters.status ) {
			urlParameters['status'] = $scope.imageFilters.status;
		}

		if( $scope.imageFilters.format ) {
			urlParameters['format'] = $scope.imageFilters.format;
		}

		if( $scope.imageFilters.sorting ) {
			urlParameters['sorting'] = $scope.imageFilters.sorting;
		}

		if( $scope.imageFilters.effect ) {
			urlParameters['effect'] = $scope.imageFilters.effect;
		}

		if( $scope.imageFilters.type ) {
			urlParameters['type'] = $scope.imageFilters.type;
		}

		if( $scope.imageFilters.searchQuery ) {
			urlParameters['search'] = $scope.imageFilters.searchQuery;
		}

		if( window.editor_browsing ) {
			urlParameters['editor_browsing'] = true;
		}

		if( initialLoad ) {
			urlParameters['initialLoad'] = true;
			initialLoad = false;
		}

		for( var urlParamater in urlParameters ) {
			returnUrl = addParameterToURL( returnUrl, urlParamater, urlParameters[urlParamater] );
		}

		return returnUrl;

	}

	$scope.$watch(function () {
		return {
			imageFilters: $scope.imageFilters,
		}
	}, function (newFilters, oldFilters) {

		if( newFilters == oldFilters ) {
			return;
		}
		
		$scope.$emit( 'reloadImages' );
		
	}, true);

	$scope.isEmpty = function (obj) {
		for (var i in obj) if (obj.hasOwnProperty(i)) return false;
		return true;
	};

}]);

function addParameterToURL(url, key, param){
    url += '&' + key + '=' + param;
    return url;
}